<template>
  <div>
    <Cards
      :data="listCards"
      @open="val => (openNegotiate = val)"
      @itemSelected="val => ((itemSelected = val), (loader = true), searchReceitas())"
    />

    <v-dialog
      id="negotiation"
      v-model="openNegotiate"
      max-width="1420px"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between blue darken-1 white--text app-card-title pa-5">
          <h4 style="font-size: 18px !important; text-transform: uppercase">
            Negociação de Taxa
          </h4>
          <v-btn
            text
            icon
            color="#FFFF"
            class="closeModalSimulator"
            @click="cleanForms()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-layout row>
            <v-flex
              lg12
              sm12
              class="mb-5 mt-5"
            >
              <header class="revenueContributor d-flex justify-space-around align-item-center justify-center pa-3 revenue-header">
                <h4 class="ma-0">
                  <strong>Contribuinte: </strong>
                  {{ userGessan?.nome }}
                </h4>
                <h4 class="ma-0 ml-3">
                  <strong>CNPJ: </strong>
                  {{ userGessan?.cnpj | cnpjCpf }}
                </h4>
              </header>
            </v-flex>
            <v-flex
              v-if="!loader"
              lg12
              sm12
            >
              <section class="pa-6 mb-5">
                <h3 class="mb-3">
                  Receitas aptas para parcelamento |
                  {{ itemSelected.nameReceita }} - {{ itemSelected.name }}
                </h3>
                <v-data-table
                  v-model="aptaSelected"
                  class="revenueNegotiation"
                  :headers="headersRevenue"
                  :items="aptasItems"
                  :loading="tableLoading"
                  :options.sync="paginationAptas"
                  :server-items-length="aptasTotal"
                  :footer-props="{
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions: [5, 10, 20, 50],
                  }"
                  selectable-key
                  show-select
                  style="border: solid 0.1px #d6dadb"
                >
                  <template #item.dataCadastro="{ item }">
                    {{ formatDate(item.dataCadastro) }}
                  </template>

                  <template #item.dataVencimento="{ item }">
                    {{ formatDate(item.dataVencimento) }}
                  </template>

                  <template #item.valorTotal="{ item }">
                    R$ {{ item.valorTotal | monetary }}
                  </template>

                  <template #item.competencia="{ item }">
                    <div class="pa-3">
                      {{ item.competencia | competencia(item.competenciaFormato) }}
                    </div>
                  </template>
                </v-data-table>
              </section>
              <div class="revenue-header mb-10 elevation-0 pa-5">
                <h4>
                  <strong style="text-transform: uppercase">Dados da Negociação</strong>
                </h4>
                <v-row class="mt-0 mb-4 blue lighten-4 pa-3 revenue-header-row">
                  <v-flex
                    lg4
                    sm6
                  >
                    <article class="revenuePrice">
                      <span>Valor a negociar</span>
                      <h1>R$ {{ revenueValueTotalsSelected | monetary }}</h1>
                    </article>
                  </v-flex>
                  <v-flex
                    lg4
                    sm6
                  >
                    <article class="revenuePrice">
                      <span>Valor atualizado</span>
                      <h1>R$ {{ valorAtualizado | monetary }}</h1>
                    </article>
                  </v-flex>
                  <v-flex
                    lg4
                    sm6
                  >
                    <article class="negotiationPrice">
                      <span>Valor a pagar</span>
                      <h1>R$ {{ valorTotalApagar | monetary }}</h1>
                    </article>
                  </v-flex>
                </v-row>
                <div class="pa-5">
                  <v-row>
                    <v-flex
                      lg4
                      sm4
                    >
                      <v-menu
                        v-model="negociacaoData.menu"
                        :close-on-content-click="false"
                        max-width="290"
                      >
                        <template #activator="{ on }">
                          <v-text-field
                            :value="dateNegociacao"
                            label="Data de Negociação"
                            clearable
                            outlined
                            readonly
                            :disabled="true"
                            class="mr-2"
                            v-on="on"
                            @click:clear="negociacaoData.date = null"
                          />
                        </template>
                        <v-date-picker
                          v-model="negociacaoData.date"
                          :disabled="aptaSelected.length === 0 || fixedDate"
                          @change="negociacaoData.menu = false"
                        />
                      </v-menu>
                    </v-flex>
                    <v-flex
                      lg4
                      sm4
                    >
                      <v-menu
                        v-model="vencimentoNegociacao.menu"
                        :close-on-content-click="false"
                        max-width="290"
                      >
                        <template #activator="{ on }">
                          <v-text-field
                            :value="dateVencimentoNegociacao"
                            label="Data de Vencimento"
                            clearable
                            outlined
                            readonly
                            :disabled="aptaSelected.length === 0 || fixedDate"
                            class="mr-2"
                            v-on="on"
                            @click:clear="vencimentoNegociacao.date = null"
                          />
                        </template>
                        <v-date-picker
                          v-model="vencimentoNegociacao.date"
                          :min="dateMin"
                          :disabled="aptaSelected.length === 0 || fixedDate"
                          @change="vencimentoNegociacao.menu = false"
                        />
                      </v-menu>
                    </v-flex>
                    <v-flex
                      lg4
                      sm4
                      class="-mt-5"
                    >
                      <v-select
                        v-model="divided"
                        outlined
                        :items="parcels"
                        :disabled="aptaSelected.length === 0"
                        label="Quantidade de Parcelas"
                      />
                    </v-flex>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      class="d-flex justify-end"
                    >
                      <v-tooltip bottom>
                        <template #activator="{ on }">
                          <v-btn
                            text
                            color="blue"
                            class="mr-0"
                            :disabled="aptaSelected.length === 0"
                            v-on="on"
                            @click="simulacaoNegociacao"
                          >
                            <v-icon>sync</v-icon> Negociar
                          </v-btn>
                        </template>
                        <span>Negociar</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <v-card-text v-if="revenueNegotiation.parcelamentos.length">
                <strong style="text-transform: uppercase">Negociação</strong>
                <v-data-table
                  class="elevation-1"
                  :headers="headersNegotiation"
                  :items="revenueNegotiation.parcelamentos"
                  :footer-props="{
                    showFirstLastPage: true,
                    showCurrentPage: true,
                  }"
                >
                  <template #body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item, index) in items"
                        :key="index"
                      >
                        <td>{{ item.numeroParcelas }}° Parcela</td>
                        <td>R$ {{ item.valorTotal | monetary }}</td>
                        <td>R$ {{ item.valorJurosParcela | monetary }}</td>
                        <td>R$ {{ item.valorAmortizacao | monetary }}</td>
                        <td>R$ {{ item.valorSaldoDevedor | monetary }}</td>
                        <td>{{ item.descricaoSefazReceita }}</td>
                        <td>{{ item.descricaoProdutoSefaz }}</td>
                        <td>{{ formatDate(item.dataVencimento) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>

                <v-btn
                  depressed
                  large
                  block
                  :disabled="!revenueNegotiation.parcelamentos.length"
                  class="mb-2 mr-2 mt-7 white--text"
                  color="green"
                  @click="saveNegociacao"
                >
                  <v-icon left dark>sync</v-icon>
                  Fazer Negociação
                </v-btn>
              </v-card-text>
            </v-flex>
            <v-flex v-else>
              <v-container
                fill-height
                style="height: 350px"
              >
                <v-row
                  align="center"
                  justify="center"
                  class="text-center"
                >
                  <v-col cols="12">
                    <section class="d-flex flex-column align-center justify-center">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        class="mb-3"
                      />
                      <strong>{{ textLoader }}</strong>
                    </section>
                  </v-col>
                </v-row>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <LoaderDialog
      :active-dialog="loaderDialogActive"
      message="Gerando DAE"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { monetaryFormat, competenciaFormat, cnpjCpfFormat } from "@/util/filters";
import NewNegociation from "@/services/financeiro/new-negociation.service";
import taxaRegulacaoService from "@/services/financeiro/taxa-regulacao.service";
import AuthService from "@/services/gessan/auth.service";
import Cards from "./components/Cards.vue";
import LoaderDialog from "./components/LoaderDialog.vue";

const global = mapState("global", ["userGessan"]);

export default {
  name: "DialogSimulation",
  components: { Cards, LoaderDialog },
  filters: {
    monetary: monetaryFormat,
    competencia: competenciaFormat,
    cnpjCpf: cnpjCpfFormat,
  },
  props: {
    listCards: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    headersRevenue: [
      { text: "Código", value: "id" },
      { text: "Receita", value: "sefazReceita.descricao", sortable: false },
      { text: "Produto", value: "sefazProduto.descricao", sortable: false },
      { text: "Competência", value: "competencia" },
      { text: "Data Vencimento", value: "dataVencimento" },
      { text: "Moeda", value: "moeda" },
      { text: "Data Criação/Lavratura", value: "dataCadastro" },
      { text: "Valor", value: "valorTotal" },
    ],
    headersNegotiation: [
      { text: "Parcela", value: "numeroParcelas", sortable: false },
      { text: "Valor", value: "valorPrincipal", sortable: false },
      { text: "Juros parcela", value: "valorJurosParcela", sortable: false },
      { text: "Valor amortização", value: "valorAmortizacao", sortable: false },
      { text: "Saldo devedor", value: "valorSaldoDevedor", sortable: false },
      { text: "Receita", value: "descricaoSefazReceita", sortable: false },
      { text: "Produto", value: "descricaoProdutoSefaz", sortable: false },
      { text: "Data vencimento", value: "dataVencimento", sortable: false },
    ],
    openNegotiate: false,
    itemSelected: [],
    valorAtualizado: 0,
    paginationAptas: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ["dataCadastro"],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
      size: 10,
    },
    aptasTotal: 0,
    aptasItems: [],
    tableLoading: false,
    aptaSelected: [],
    revenueNegotiation: {
      parcelamentos: [],
    },
    negociacaoData: {
      date: moment().format("YYYY-MM-DD"),
      menu: false,
    },
    vencimentoNegociacao: {
      date: null,
      menu: false,
    },
    negociacaoObservacao: "Negociação criada a partir da Central de Serviços do Saneamento",
    parcels: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
    divided: "",
    loader: false,
    textLoader: "Carregando...",
    valorTotalApagar: 0,
    dateToday: moment().format("YYYY-MM-DD"),
    fixedDate: false,
    loaderDialogActive: false,
  }),
  computed: {
    ...global,
    revenueValueTotalsSelected() {
      return this.aptaSelected.map(r => r.valorTotal).reduce((r1, r2) => r1 + r2, 0);
    },
    dateVencimentoNegociacao() {
      return this.vencimentoNegociacao.date
        ? moment(this.vencimentoNegociacao.date).format("DD/MM/YYYY")
        : "";
    },
    dateNegociacao() {
      return this.negociacaoData.date ? moment(this.negociacaoData.date).format("DD/MM/YYYY") : "";
    },
    dateMin() {
      return moment().add(1, "days").format("YYYY-MM-DD");
    },
  },
  watch: {
    paginationAptas: {
      handler(val, oldVal) {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.searchReceitas();
        }
      },
    },
    aptaSelected: {
      handler(val) {
        const checkStatusGroup = val.some(
          e => e.quantidadeParcelamento == 1 || e.quantidadeParcelamento == 2
        );

        if (checkStatusGroup) {
          this.fixedDate = true;
          this.negociacaoData.date = this.dateToday;
          this.vencimentoNegociacao.date = moment().add(2, "days").format("YYYY-MM-DD");
        } else {
          this.fixedDate = false;
          this.vencimentoNegociacao.date = null;
        }
      },
    },
  },
  methods: {
    cleanForms() {
      this.openNegotiate = false;
      this.divided = null;
      this.vencimentoNegociacao.date = null;
      this.negociacaoData.date = this.dateToday;
      this.revenueNegotiation.parcelamentos = [];
      this.aptasItems = [];
      this.tableLoading = false;
      this.valorAtualizado = 0;
      this.valorTotalApagar = 0;
      this.paginationAptas = {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["dataCadastro"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
        size: 10,
      };
      this.aptaSelected = [];
    },
    searchReceitas() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.paginationAptas;

      this.tableLoading = true;

      taxaRegulacaoService
        .listReceitasSaneamento({
          cpfCnpj: this.userGessan?.cnpj,
          page: page - 1,
          size: itemsPerPage == -1 ? this.aptasTotal : itemsPerPage,
          ascendingSort: sortDesc[0] ?? true,
          sort: sortBy,
        })
        .subscribe(
          res => {
            const { content, pageInfo } = res;

            this.aptasItems = content;
            this.aptasTotal = pageInfo.totalElements;
            this.tableLoading = false;
            this.loader = false;
          },
          () => {
            this.aptasItems = [];
            this.tableLoading = false;
            this.loader = false;
          }
        );
    },
    simulacaoNegociacao() {
      this.loader = true;

      NewNegociation.simularNegociacao({
        cpfCnpj: this.userGessan?.cnpj,
        ids: this.aptaSelected.map(item => item.id.toString()),
        dataVencimento: this.vencimentoNegociacao.date,
        dataNegociacao: this.negociacaoData.date,
        parcelas: this.divided,
      }).subscribe(
        res => {
          const { parcelamentos, valorAtualizado, valorTotal } = res;

          this.revenueNegotiation.parcelamentos = parcelamentos;
          this.valorAtualizado = valorAtualizado;
          this.valorTotalApagar = valorTotal;
          this.loader = false;
        },
        error => {
          AuthService.globalStore(
            "error",
            error?.response?.data?.message || "Não foi possível processar a requisição"
          );
          this.loader = false;
        }
      );
    },
    saveNegociacao() {
      NewNegociation.saveNegociacao({
        cpfCnpj: this.userGessan?.cnpj,
        ids: this.aptaSelected.map(item => item.id.toString()),
        divided: this.divided,
        date: this.vencimentoNegociacao.date,
        dateNegotiation: this.negociacaoData.date,
        observacao: this.negociacaoObservacao,
      }).subscribe(
        res => {
          NewNegociation.historicoNegociacao(
            this.userGessan?.cnpj,
            this.aptaSelected.map(item => item.id.toString())
          ).subscribe(
            () => {
              AuthService.globalStore("success", "Negociação realizada com sucesso!");
            },
            () => {}
          );

          this.$emit("updateList", true);
          this.cleanForms();

          const idReceita = res.parcelamentos.find(p => p.numeroParcelas == 1).id;

          this.loaderDialogActive = true;
          this.baixarDae(idReceita);
        },
        () => {
          AuthService.globalStore("error", "Não foi possível processar a requisição");
        }
      );
    },
    baixarDae(idReceita) {
      NewNegociation.baixarDae(this.userGessan?.cnpj, [idReceita.toString()], this.dateToday).subscribe(
        res => {
          const file = new Blob([res], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);

          window.open(fileURL);
          this.loaderDialogActive = false;
        },
        () => {
          AuthService.globalStore("error", "Não foi possível gerar DAE");
          this.loaderDialogActive = false;
        }
      );
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
  },
};
</script>

<style scoped>
.revenueNegotiation {
  margin-bottom: 30px;
}

.revenue-header {
  border: solid 0.1px #d6dadb;
  border-radius: 5px;
}
</style>
